import { createVanIconComponent } from "./van"

const Gem = createVanIconComponent("gem")
export default Gem
